import type { Offer } from '@fourthwall/services/dist/models/offer'

import { useOffer } from '../../../../hooks/useOffer'
import { useOfferOrdersByVariantsAnalyticsQuery } from '../../../hooks/useOfferOrdersByVariantsAnalyticsQuery'
import { useVariantsAnalyticsQuery } from '../../../hooks/useVariantsAnalyticsQuery'
import { flattenVariantGroups, getPreviewImageUrl, getVariantsGroups } from '../utils'

export const useVariants = (offerVariants: Offer.Variant[], offerId: string) => {
  const { offer } = useOffer(offerId)

  const { offerOrdersByVariantsAnalyticsQuery } = useOfferOrdersByVariantsAnalyticsQuery([
    { offerId },
  ])
  const variantsIds = Object.keys(
    offerOrdersByVariantsAnalyticsQuery.data?.notArchivedVariantsSales || {},
  )
  const { variantsAnalyticsQuery } = useVariantsAnalyticsQuery([{ ids: variantsIds }], {
    enabled: !!variantsIds.length,
  })

  const variantGroups = getVariantsGroups(offerVariants, offer.variantTypes)
  const flatVariants = flattenVariantGroups(variantGroups)

  const getExternalStock = (variantId: string) => {
    const stockDetails = variantsAnalyticsQuery.data?.items?.[variantId]?.stockDetails

    if (offer.fulfillmentService === 'SHIP_MONK') {
      return stockDetails?.shipMonkStockExists ? stockDetails.shipMonkStockAvailable : 'N/A'
    }

    if (
      offer.fulfillmentService === 'WHIPLASH_3PL' ||
      offer.fulfillmentService === 'WHIPLASH_FREE'
    ) {
      return stockDetails?.whiplashStockExists ? stockDetails.whiplashStockQuantity : 'N/A'
    }

    if (offer.fulfillmentService === 'CART_JAZZ') {
      return stockDetails?.jazzStockExists ? stockDetails.jazzStockAvailable : 'N/A'
    }
  }

  const getSold = (variantId: string) =>
    offerOrdersByVariantsAnalyticsQuery.data?.notArchivedVariantsSales?.[variantId]?.unitsSold || 0

  const variants = flatVariants.map((variant) => ({
    ...variant,
    previewImage: {
      hidden: !offer.variantTypes.some((variantType) => variantType.variesBy.imagery),
      url: getPreviewImageUrl(variant.images, offer.images),
    },
    externalStock: getExternalStock(variant.id),
    sold: getSold(variant.id),
  }))

  return {
    variants,
  }
}
